import { FC, InputHTMLAttributes } from "react";
import { Input, Slider, Wrapper } from "./Toggle.styled";

interface Props extends InputHTMLAttributes<HTMLInputElement> {
  light?: boolean;
  width?: number;
  height?: number;
}

const Toggle: FC<Props> = ({ light, width, height, ...rest }) => {
  return (
    <Wrapper light={light} w={width} h={height}>
      <Input type="checkbox" {...rest} />
      <Slider light={light} h={height} />
    </Wrapper>
  );
};

export default Toggle;
